export function convertCsvToJson(originalContents) {
    if(originalContents == null || originalContents.trim() == ""){
        return;
    }


    let result;

    result = convertProcessFacade(originalContents);

    return result;
}


function convertProcessFacade(targetContent){
    let result = {};
    let targetContentArray = targetContent.split(/\r?\n/g);

    //-----< Remove Blank Line >-----
    targetContentArray = removeBlankLines(targetContentArray);


    //-----< Return If lines is 2 or less >-----
    if(targetContentArray.length <= 1){
        return;
    }

    //-----< Set Data >-----
    let headerLine = getHeaderLine(targetContentArray);
    let dataLines  = getDataLines(targetContentArray);

    result["columns"] = getColumnsContents(headerLine);
    result["rows"]    = getRowsContents(headerLine, dataLines);

    return result;
}

function removeBlankLines(targetContentArray){
    let resultContentArray = targetContentArray.filter( (el)=> el.trim().length > 0);
  
    return resultContentArray;
}

function getHeaderLine(targetContentArray){
    let resultContentArray = targetContentArray[0];
  
    return resultContentArray;
}

function getDataLines(targetContentArray){
    let resultContentArray = [];

    for(var i=1; i<targetContentArray.length; i++){
        let el = targetContentArray[i];
        resultContentArray.push(el)
    }

    return resultContentArray;
}

function getColumnsContents(targetRow){
    let result = [];
    let rowsElements = targetRow.split(",");

    rowsElements.forEach(el => {
        var col = {}
        col["label"] = el;
        col["field"] = el;
        col["sort"] = "asc";

        result.push(col);
    });

    return result;
}

function getRowsContents(headerLine, dataLines){
    let result = [];
    let headerElements = headerLine.split(",");

    dataLines.forEach(el => {
        let dataElements = el.split(","); 

        var ct = {}
        for(let i=0; i<dataElements.length; i++){
            ct[headerElements[i]] = dataElements[i];
        }
        result.push(ct);
    });

    return result;
}


